module.exports = __webpack_public_path__ + "static/img/亞太豐菱.0b69fd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/合作夥伴/亞太豐菱.png?20181011
// module id = B+L+
// module chunks = 1